import { render, staticRenderFns } from "./ChangeSpecimenToSale.vue?vue&type=template&id=534ec3d3&scoped=true"
import script from "./ChangeSpecimenToSale.vue?vue&type=script&lang=js"
export * from "./ChangeSpecimenToSale.vue?vue&type=script&lang=js"
import style0 from "./ChangeSpecimenToSale.vue?vue&type=style&index=0&id=534ec3d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ec3d3",
  null
  
)

export default component.exports